export default __webpack_public_path__ + "locales/fr/InviteDialog.json?hash=64ca5cc2b692d2ab7f9fdce6a0867803";